import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const UG3224Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "UG3224IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_562)">
        <rect width="32" height="24" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V24H32V0H0Z"
          fill="#FECA00"
        />
        <mask
          id="mask0_1813_562"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="24"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H32V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_562)">
          <rect width="32" height="4" fill="#272727" />
          <rect y="8" width="32" height="4" fill="#D74800" />
          <rect y="12" width="32" height="4" fill="#272727" />
          <rect y="20" width="32" height="4" fill="#D74800" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 18C19.3137 18 22 15.3137 22 12C22 8.68629 19.3137 6 16 6C12.6863 6 10 8.68629 10 12C10 15.3137 12.6863 18 16 18Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.6797 8.32864L12.6218 8.67579L13.6797 8.76637C13.6797 8.76637 13.8508 9.18472 13.6797 9.5113C13.6363 9.59421 13.5243 9.70043 13.3814 9.83601C12.9611 10.2345 12.2735 10.8867 12.2735 11.9462C12.2735 13.3663 15.014 14.0102 15.014 14.0102V14.6849C15.014 14.6849 15.3321 14.8824 13.5173 14.8824C11.9434 14.8824 12.0419 15.4799 12.0957 15.8069C12.104 15.857 12.1112 15.9008 12.1112 15.935C12.1112 16.1933 12.8676 15.6768 13.2217 15.1626C13.4081 14.892 14.1887 14.9063 14.9898 14.9805C15.0531 14.9864 15.6372 16.2237 15.1301 16.8629C14.9171 17.1314 14.1814 17.1664 13.7217 17.1883C13.4874 17.1994 13.3248 17.2071 13.3399 17.2407C13.3512 17.2658 13.4898 17.2576 13.6913 17.2455C13.9427 17.2305 14.2921 17.2097 14.6141 17.2407C14.663 17.2454 14.4735 17.4099 14.2819 17.5762C14.0845 17.7475 13.8849 17.9207 13.9412 17.9234C14.0044 17.9263 14.374 17.7216 14.7097 17.5356C14.9875 17.3817 15.2421 17.2407 15.2809 17.2407C15.5343 17.2407 15.7631 17.2719 15.9637 17.2994C16.2991 17.3452 16.556 17.3803 16.7177 17.2407C16.7675 17.1977 16.4788 17.1285 16.1844 17.058C15.8812 16.9854 15.5719 16.9113 15.6207 16.8629C15.8994 16.5863 15.783 16.0064 15.6913 15.5498C15.6501 15.3449 15.614 15.1648 15.6207 15.048C15.6445 14.6332 16.0833 14.8508 16.4281 15.0218C16.5791 15.0967 16.7121 15.1626 16.7843 15.1626C17.4373 15.1626 16.6265 14.3367 16.1815 13.8834C16.1425 13.8437 16.1063 13.8068 16.0741 13.7736C15.8478 13.5399 16.0066 13.5713 16.3654 13.6423C16.6392 13.6964 17.0295 13.7736 17.4541 13.7736C18.4351 13.7736 19.1511 13.4549 18.9024 12.592C18.7383 12.0227 17.8398 11.829 16.9012 11.6266C16.417 11.5222 15.9222 11.4155 15.5119 11.2538C14.5025 10.8559 14.554 10.2758 14.5975 9.78534C14.6059 9.68994 14.6141 9.59793 14.6141 9.5113C14.6141 8.97929 15.5119 8.32864 15.5119 8.32864C15.5119 8.32864 15.1022 7.64209 14.4227 7.64209C13.7432 7.64209 13.6797 8.32864 13.6797 8.32864ZM15.5279 14.5765V14.0747C15.5279 14.0747 15.9475 14.0609 16.0946 14.4138C16.2418 14.7668 15.5279 14.5765 15.5279 14.5765Z"
            fill="#272727"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.0771 6.71104L14.0907 7.91298L14.6156 7.78952L14.3639 6.57617L13.0771 6.71104Z"
            fill="#D74800"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.393 6.42052L14.4584 8.22757L15.3238 8.01461L15.6924 6.83109L14.393 6.42052Z"
            fill="#FFD018"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5771 9.43867C13.7683 9.43867 13.9233 9.28757 13.9233 9.10117C13.9233 8.91478 13.7683 8.76367 13.5771 8.76367C13.3859 8.76367 13.231 8.91478 13.231 9.10117C13.231 9.28757 13.3859 9.43867 13.5771 9.43867Z"
            fill="#D74800"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7769 6.75901L14.7692 7.9659L14.9819 8.46138L16.1331 8.00278L15.7769 6.75901Z"
            fill="#D74800"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.1187 15.893C18.1187 15.893 19.8911 15.1012 19.8911 13.9939C19.8911 12.8866 17.0131 11.6804 17.0131 11.6804C17.0131 11.6804 15.3202 12.0679 16.0833 12.5864C16.8463 13.1049 17.8687 13.3041 17.8687 13.9939C17.8687 14.6837 18.1487 15.3414 17.5809 15.3414C17.0131 15.3414 18.1187 15.893 18.1187 15.893Z"
            fill="#D74800"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5618 11.478C15.5618 11.478 14.935 11.5881 14.9647 11.69C15.047 11.9714 15.9042 12.3381 16.2777 12.5919C17.0408 13.1104 17.7642 13.0522 18.3025 12.7147C18.8407 12.3773 15.5618 11.478 15.5618 11.478Z"
            fill="#FFFDFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_562">
          <rect width="32" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UG3224Icon;
